import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { legalLinkClass } from './legalStyles';

interface LegalLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

/** In-app link between legal pages (inherits dark-mode link colors). */
const LegalLink: React.FC<LegalLinkProps> = ({ to, children, className = '' }) => {
  const [searchParams] = useSearchParams();
  const fromSettings = searchParams.get('from') === 'settings';
  const href = fromSettings ? `${to}?from=settings` : to;

  return (
    <Link to={href} className={`${legalLinkClass} ${className}`.trim()}>
      {children}
    </Link>
  );
};

export default LegalLink;
